import { useState } from "react";
import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";
import { Flashbar } from "@amzn/awsui-components-react";

import NavigationBreadcrumbs from "../../common/navigation/NavigationBreadcrumbs";
import SideNavigationMenu from "../../common/navigation/SideNavigationMenu";
import Paths from "../../common/paths/paths";
import { useFlashBarItems } from "../../common/UseFlashBarItems/useFlashBarItems";
import { BulkOrdersTemplatesTable } from "../../components/BulkOrdersTemplates/BulkOrdersTemplatesTable";

const breadcrumbs = {
    items: [
        { text: Paths.Admin.name, href: Paths.uploadLicense.url },
        { text: Paths.bulkOrdersTemplates.name, href: Paths.bulkOrdersTemplates.url },
    ],
};

const BulkOrdersTemplatesPage = () => {
    const [navigationOpen, setNavigationOpen] = useState(false);
    const flashBarItemsHook = useFlashBarItems();

    return (
        <AppLayout
            content={<BulkOrdersTemplatesTable useFlashBarItemsActions={flashBarItemsHook.actions} />}
            breadcrumbs={<NavigationBreadcrumbs items={breadcrumbs.items} />}
            navigation={<SideNavigationMenu />}
            navigationOpen={navigationOpen}
            notifications={<Flashbar items={flashBarItemsHook.flashBarItems} stackItems />}
            onNavigationChange={(event: any) => setNavigationOpen(event.detail.open)}
            toolsHide={true}
        />
    );
};

export default BulkOrdersTemplatesPage;
